import React from "react";
import "./App.scss";
import AppRoutes from "./routes";
import {ConfigProvider} from "antd";
import enUS from 'antd/lib/locale/en_US';
import colors from "./Utils/colors";

function App() {
  return (
    <ConfigProvider
      locale={enUS}
      theme={{
        token: {
          ...colors,
          borderRadius: 4,
        },
        components: {
          Segmented: {
            ...colors,
          },
        },
      }}
    >
      <AppRoutes />
    </ConfigProvider>
  );
}

export default App;
